import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import MediaImageField from "@/components/common/MediaImageField";
import { resolveMediaUrl } from "@/lib/serviceMedia";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const Field = ({ label, children, hint }) => (
  <div className="space-y-1">
    <Label className="text-xs text-white/50">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-white/40">{hint}</p>}
  </div>
);

export default function Challenges() {
  return (
    <OrderedModuleEditor
      resource="admin/site/challenges"
      singular="challenge"
      title="Challenges"
      subtitle="Drag to reorder challenge stories and edit media in the inspector."
      titleKey="title"
      defaultValues={{ order: 1, icon: "", title: "", body: "", reverse: false, media: null, status: "published" }}
      enableStatus
      getItemLabel={(it, idx) => it.title || `Challenge ${idx + 1}`}
      renderPreviewItem={(it, idx) => {
        const thumb = resolveMediaUrl(it.media?.src) || "";
        return (
          <div className={`flex gap-3 items-start ${it.reverse ? "flex-row-reverse" : ""}`}>
            {thumb ? (
              <img src={thumb} alt="" className="w-16 h-16 rounded-lg object-cover shrink-0 bg-white/5" />
            ) : (
              <span className="w-16 h-16 rounded-lg glass flex items-center justify-center text-sm font-mono text-white/60 shrink-0">
                {it.icon || String(idx + 1).padStart(2, "0")}
              </span>
            )}
            <div className="min-w-0">
              <div className="text-sm font-medium text-white">{it.title || "Untitled"}</div>
              <p className="text-xs text-white/50 mt-1 line-clamp-2">
                {Array.isArray(it.body) ? it.body.join(" ") : (it.body || "")}
              </p>
            </div>
          </div>
        );
      }}
      renderInspector={(item, patch) => (
        <>
          <Field label="Icon">
            <Input value={item.icon || ""} onChange={(e) => patch({ icon: e.target.value })} placeholder="BR" className="bg-black/20 border-white/10 text-white" />
          </Field>
          <Field label="Title">
            <Input value={item.title || ""} onChange={(e) => patch({ title: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
          <Field label="Body" hint="One paragraph per line">
            <Textarea
              value={Array.isArray(item.body) ? item.body.join("\n") : (item.body || "")}
              onChange={(e) => patch({ body: e.target.value.split("\n").filter(Boolean) })}
              rows={5}
              className="bg-black/20 border-white/10 text-white"
            />
          </Field>
          <MediaImageField
            label="Image"
            value={item.media}
            onChange={(media) => patch({ media })}
            folder="challenges"
            valueMode="media"
            aspectClass="h-28"
          />
          <div className="flex items-center justify-between gap-3 pt-1">
            <span className="text-xs text-white/60">Reverse layout</span>
            <Switch checked={!!item.reverse} onCheckedChange={(v) => patch({ reverse: v })} />
          </div>
        </>
      )}
    />
  );
}
